<template>
  <div class="contentHome">
    <div class="centerPage">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item><a href="javascript:;" @click="$router.back(-1)" class="aHref">医生详情</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>预约订单</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="flex" style="justify-content: space-between;align-items: normal">
        <div :class="coupons.length==0?'maxWidth':''">
          <el-steps :active="active" align-center class="stepRes">
            <el-step v-for="(item,index) in titleList" :title="item.title" :key="index"></el-step>
          </el-steps>
          <div class="doctor">
            <template v-if="active===0">
              <div class="userList flex">
                <div class="objImg img"  :style="'backgroundImage: url('+doctor.headImgPath+')'"></div>
                <div class="right">
                  <div class="flex">
                    <h2>{{ doctor.fullName }} {{ doctor.enName }}</h2>
                    <span class="serviceLength">从业<strong>{{ workYear }}</strong>年</span>
                  </div>
                  <span class="count">已咨询<strong>{{ doctor.consultationCount }}</strong>人</span>
                  <div style="clear: both"></div>
                  <p>
                    <span class="post" style="margin-left: 0">{{ doctor.technicalTitle }}</span>
                    <span class="post">{{ doctor.certSource }}</span>
                    <span class="post ">{{ doctor.job }}</span>
                  </p>
                  <p class="motto">{{ doctor.signature }}</p>
                  <p class="tag-language">{{ languageTags.join('/') }}</p>
                  <span class="pay">
                    {{ doctor.initialCharge }}元 / {{ doctor.initialMinute }}分钟
                    <template v-if="doctor.specialNote">（{{ doctor.specialNote }}）</template>
                  </span>
                  <span class="count">所在地<span class="abodeCity">{{ doctor.abodeCity }}</span></span>
                  <div style="clear: both"></div>
                </div>
              </div>
              <div v-loading="loading">
                <!--                预约时间 start-->
                <appointment ref="appointment" :account="doctorAccount" @selectCBK="selectCBK"></appointment>
                <!--                预约时间end-->

                <!--提交预约信息 start-->
                <div class="appointInfo">
                  <p class="tit">提交预约信息<span>（真实信息有助于医师准确判断）</span></p>
                  <el-form ref="form" class="doctorLogin" :model="appoint" label-width="80px"
                           hide-required-asterisk
                           label-suffix="：">
                    <el-form-item label="咨询方式">
                      <template v-if="doctor.consultMode == 1">
                        <el-radio-group v-model="appoint.consultMode" class="sex">
                          <el-radio :label="1">语音</el-radio>
                        </el-radio-group>
                      </template>
                      <template v-else-if="doctor.consultMode == 2">
                        <el-radio-group v-model="appoint.consultMode" class="sex">
                          <el-radio :label="2">视频</el-radio>
                          <el-radio :label="1">语音</el-radio>
                        </el-radio-group>
                      </template>
                    </el-form-item>
                    <el-form-item label="咨询语言" v-if="languageTags.length>0">
                      <el-radio-group v-model="appoint.consultLanguage" class="sex">
                        <el-radio :label="tag" v-for="tag in languageTags" :key="tag">{{ tag }}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <div class="flex">
                      <el-form-item label="称呼" prop="realName">
                        <el-input v-model="appoint.realName" placeholder="医生对你的称呼"></el-input>
                      </el-form-item>
                      <el-form-item label="年龄" prop="age">
                        <el-input-number v-model="appoint.age" placeholder="年龄"
                                         prop=""></el-input-number>
                      </el-form-item>
                      <el-form-item label="性别" prop="gender">
                        <el-radio-group v-model="appoint.gender" class="sex">
                          <el-radio :label="1">男</el-radio>
                          <el-radio :label="0">女</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                    <div class="flex">
                      <el-form-item label="所在城市" prop="abodeCity">
                        <el-input v-model="appoint.abodeCity" placeholder="所在城市"></el-input>
                      </el-form-item>
                      <el-form-item label="职业" prop="occupation">
                        <el-input v-model="appoint.occupation" placeholder="职业"></el-input>
                      </el-form-item>
                    </div>

                    <el-form-item label="问题描述" prop="problemDesc">
                      <el-input type="textarea" style="width: 800px" :autosize="{ minRows: 4, maxRows: 5}"
                                v-model="appoint.problemDesc" placeholder="问题描述"></el-input>
                    </el-form-item>
                    <el-form-item label="期望效果" prop="expectEffect">
                      <el-input type="textarea" style="width: 800px"
                                :autosize="{ minRows: 4, maxRows: 5}"
                                v-model="appoint.expectEffect" placeholder="期望效果"></el-input>
                    </el-form-item>

                  </el-form>
                  <p class="tit">上传附件</p>
                  <div style="margin: 20px 0;">
                    <el-upload
                        class="upload-block"
                        name="uploadFile"
                        :action="upload.url"
                        :on-success="uploadSuccess"
                        :before-remove="beforeRemove"
                        :on-remove="handleRemove"
                        :headers="upload.headers"
                        multiple
                        :limit="10"
                        :on-exceed="handleExceed">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <span class="upload-tips">最多上传10个附件,且不超过10M</span>
                    </el-upload>

                  </div>
                  <p class="tit">可用优惠券</p>
                  <div class="coupon-list">
                    <p v-if="myCoupons.length==0"
                       style="color: #999999; font-size: 13px; margin-top: 20px">您还没有优惠券</p>
                    <div class="coupon flex" v-for="item in myCoupons"
                         :class="item.couponType == 2|| item.couponType == 3? 'specialBg' : ''"
                         :key="item.id"
                         @click="selectCoupon(item)">
                      <div class="type" v-if="item.couponType != 1">
                        {{ item.couponType == 2 ? '月卡' : (item.couponType == 3 ? '年卡' : '-') }}
                      </div>
                      <div class="type" v-else>
                        {{ item|couponDiscountFmt }}
                      </div>
                      <div class="info flex">
                        <el-tooltip effect="dark" :content="item.couponTitle" placement="top-start">
                          <div class="name overFlow">{{ item.couponTitle }}</div>
                        </el-tooltip>
                        <div>{{ new Date(item.limitStartDate).Format('yy.MM.dd') }} -
                          {{ new Date(item.limitEndDate).Format('yy.MM.dd') }}
                        </div>
                        <div v-if="item.couponType != 1"
                             style="font-size: 12px;">剩余{{ item.limitUseCount - item.usedCount }}次可用
                        </div>
                      </div>
                      <span class="selector" :use="item.checked"></span>
                    </div>
                    <div style="clear:both;"></div>
                  </div>
                  <el-checkbox v-model="checked" :label="true" class="agreeFile">
                    我已阅读并同意 <a class="agreement" target="_blank" href="/agreement/consult">《心理亦笙》咨询预约协议</a>
                  </el-checkbox>
                  <div class="btnGroup flex" style="flex-flow: column;line-height: 2;color: #FC7B66">
                    <h4>应付金额：￥{{ appoint.payAmount }}</h4>
                    <el-button @click="submitAppoint" v-if="active!=2" class="next">提交预约</el-button>
                  </div>
                </div>

              </div>
            </template>
          </div>
        </div>
        <!--        优惠券-->
        <div class="couponsList">
          <div v-for="item in coupons" class="coupons"
               :class="item.couponType == 2|| item.couponType == 3? 'special' : ''" :key="item.id">
            <div class="borderCou">
              <template v-if="item.couponType == 1">
                <el-tooltip effect="dark" :content="item.couponTitle" placement="top-start">
                  <div class="name overFlow">{{ item.couponTitle }}</div>
                </el-tooltip>
                <div class="discount">{{ item|couponDiscountFmt }}</div>
                <p class="title" v-if="item.fullReductionAmount>0">满{{ item.fullReductionAmount }}元可用</p>
                <p class="stackable"> {{ (item.stackable == 0 ? '不' : '') + '可叠加' }}</p>
              </template>
              <template v-else>
                <div class="discount">{{ item.couponType == 2 ? '月卡' : '年卡' }}</div>
                <p class="title">可用{{ item.useLimitCount }}次</p>
              </template>
              <div class="time">有效期至：{{ new Date(item.endUseDate).Format('yyyy.MM.dd') }}</div>
            </div>
            <span class="op-gain" v-if="item.couponType ==1" @click="gainCoupon(item.id)">领取</span>
            <span class="op-gain" v-else @click="couponPay(item)">购买(￥{{ (item.price / 100).toFixed(2) }})</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :show-close="false"
        class="tips paySuccess"
        top="0"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px">
      <img src="../../assets/img/success.png" alt="" width="140">
      <p>提交成功！请准时参加会诊</p>
      <div class="sub">
        <el-button @click="pay">我知道了</el-button>
      </div>
    </el-dialog>

    <!--    支付-->
    <el-dialog
        class="purchase" center
        top="0"
        :visible.sync="couponPayDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeCouponPay"
        width="500px">
      <div class="code">
        <div class="flex qr-img" v-loading="couponPayDialog.qrLoading">
          <img :src="couponPayDialog.qrImgSrc" alt="">
        </div>
        <p class="count-down" v-if="!couponPayDialog.qrLoading">{{ couponPayDialog.expireText }}</p>
        <p>微信支付</p>
      </div>
      <div class="purchaseInfo">
        <h2 class="couponType">{{ couponPayDialog.couponInfo.couponType == 2 ? '月卡' : '年卡' }}购买</h2>
        <p class="tit">可预约咨询{{ couponPayDialog.couponInfo.useLimitCount }}次</p>
        <p class="tit">有效日期：{{
            new Date(couponPayDialog.couponInfo.startUseDate).Format('yyyy-MM-dd HH:mm:ss')
          }}</p>
        <p class="tit">结束日期：{{
            new Date(couponPayDialog.couponInfo.endUseDate).Format('yyyy-MM-dd HH:mm:ss')
          }}</p>
        <div class="tit flex">支付金额：<h2>￥{{ (couponPayDialog.couponInfo.price / 100).toFixed(2) }}</h2></div>
        <div class="text">说明：{{ couponPayDialog.couponInfo.couponExplain }}</div>
      </div>
    </el-dialog>

    <el-dialog
        :show-close="false"
        class="tips paySuccess"
        top="0"
        :visible.sync="successDialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="400px">
      <img src="../../assets/img/success.png" alt="" width="140">
      <p>预约成功！请准时进行咨询</p>
      <div class="sub">
        <el-button @click="$router.push('/user/counsel')">我知道了</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "reservationOrder",
  data() {
    return {
      doctorAccount: this.$route.params.account || '',

      loading: false,
      successDialogVisible: false,
      qrLoading: true,
      workYear: 0,
      active: 0,
      titleList: [{
        title: '填写订单',
      }, {
        title: '付款',
      }, {
        title: '咨询',
      }],
      doctor: {},
      appoint: {
        consultMode: 2,
        consultLanguage: '',
        realName: '',
        age: 18,
        gender: null,
        abodeCity: '',
        occupation: '',
        mobile: '',
        email: '',
        problemDesc: '',
        expectEffect: '',
        payAmount: 0,
        totalAmount: 0,
      },
      checked: false,
      payWay: '1',
      dialogVisible: false,
      state: this.$route.query.state,
      choosed: {},

      initAmount: 0,
      coupons: [], //优惠券列表
      myCoupons: [],

      couponPayDialog: {
        visible: false,
        qrImgSrc: '',
        qrLoading: false,
        expire: 0, // 二维码有效期
        expireTimer: 0, //倒计时
        timeDelayer: 0, // 延时请求
        expireText: '00:00',
        couponInfo: {},
        payCouponNo: '', // 二维码对应订单
      },
      upload: {
        url: base.basePath + 'medical/medical-appoint-file/authorize/upload',
        headers: {
          Authorization: 'bearer ' + localStorage.access_token
        },
      },
      fileList: [],
      languageTags: []
    }
  },
  beforeMount() {
    let vm = this;
    this.getData();
  },
  mounted() {
    document.querySelector('.homeIndex').scrollTop = 0;//返回顶部
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
    document.body.scrollTop = 0;
    // 自动填充用户信息
    this.$ajax.get(base.basePath + 'auth/auth-user/authorize/base-info/me').then(res => {
      if (res.data.status === 'success') {
        this.appoint.realName = res.data.data.fullName;
        this.appoint.age = res.data.data.age;
        // this.appoint.gender = res.data.data.gender;
        this.appoint.abodeCity = res.data.data.abodeCity;
        this.appoint.occupation = res.data.data.workJob;
        //this.appoint.mobile = res.data.data.mobile;
        //this.appoint.email = res.data.data.email;
      }
    }).catch(err => {
      console.error('个人信息加载失败:' + err);
    })
  },
  inject: ['reload'],
  methods: {
    submitAppoint() {// 提交预约；校验是否已经选择预约时间，是否勾选同意协议
      let vm = this;
      vm.loading = true;
      const choosed = vm.choosed;
      if (!choosed.slotNum) {
        vm.$message.error('请先选择预约时间');
        vm.loading = false;
        return;
      }

      vm.appoint.appointDate = choosed.appointDate;
      vm.appoint.appointTimeSlot = choosed.appointSlot;
      vm.appoint.appointStartTime = choosed.appointStartTime;
      vm.appoint.appointStartLongtime = choosed.appointStartLongtime;
      vm.appoint.appointEndTime = choosed.appointEndTime;
      vm.appoint.appointEndLongtime = choosed.appointEndLongtime;
      vm.appoint.slotNum = choosed.slotNum;
      vm.appoint.endSlot = choosed.endSlot;


      if ($.trim(vm.appoint.consultMode).length == 0) {
        vm.$message.warning('请选择咨询模式');
        vm.loading = false;
        return;
      }
      if ($.trim(vm.appoint.realName).length == 0) {
        vm.$message.warning('请填写称呼');
        vm.loading = false;
        return;
      }
      if ($.trim(vm.appoint.age).length == 0) {
        vm.$message.warning('请输入年龄');
        vm.loading = false;
        return;
      }

      if (vm.appoint.gender != 0 && vm.appoint.gender != 1) {
        vm.$message.warning('请输选择性别');
        vm.loading = false;
        return;
      }

      if ($.trim(vm.appoint.abodeCity).length == 0) {
        vm.$message.warning('请输入所在城市');
        vm.loading = false;
        return;
      }
      if ($.trim(vm.appoint.problemDesc).length == 0) {
        vm.$message.warning('请输入问题描述');
        vm.loading = false;
        return;
      }

      if (!vm.checked) {
        vm.$message.info('请先仔细阅读《心理亦笙》咨询预约协议并勾选同意');
        vm.loading = false;
        return;
      }

      if (vm.appoint.payAmount < 0) {
        vm.$message.warning('优惠券不可用');
        vm.loading = false;
        return;
      }
      vm.appoint.doctorAccount = vm.doctor.account;
      // 加入优惠券信息
      vm.appoint.couponIdList = [];
      if (vm.myCoupons.length > 0) {
        $(vm.myCoupons).each((i, o) => {
          if (o.checked) {
            vm.appoint.couponIdList.push(o.id);
          }
        });
      }
      // 附件信息
      vm.appoint.fileIdList = vm.fileList;

      // 校验通过，提交预约
      vm.$ajax.post(base.api.appoint.save, vm.appoint).then((res) => {
        if (res.data.status == 'success') {
          if (res.data.res === 'ok') {
            // 直接至成功页面
            vm.successDialogVisible = true;
          } else {
            // 支付页面
            vm.$router.push('/user/order/' + res.data.data)
          }
        } else {
          vm.$message.error(res.data.message);
          vm.loading = false;
        }
      }).catch(err => {
        vm.$message.error('预约失败');
        vm.loading = false;
        console.error(err);
      })
    },
    num(n) {
      return n < 10 ? '0' + n : '' + n
    },
    pay() {
      this.dialogVisible = false
      this.next()
    },
    getData() {
      let account = this.$route.params.account, vm = this;
      vm.$ajax.post(base.api.doctor.consult.authorizeDetail.replace('{account}', account))
          .then((res) => {
            if (res.data.data.userType === "doctor") {
              vm.$message.error("请用普通用户登录");
              vm.$router.back(-1);
            } else {
              if (res.data.status == 'success') {
                vm.doctor = res.data.data.detail;
                vm.indicationList = res.data.data.indicationList;

                //vm.appoint.payAmount = vm.doctor.initialCharge;
                vm.initAmount = vm.doctor.initialCharge;
                vm.workYear = res.data.data.workYear;

                if (this.doctor.doctorId) {
                  // 查询是否有优惠券
                  this.$ajax.get(base.basePath + "coupon/coupon-rule/authorize/list/doctor/" + this.doctor.doctorId).then(res => {
                    if (res.data.status === 'success') {
                      this.coupons = res.data.list;
                      this.getCouponList(this.doctor.doctorId);
                    }
                  }).catch(err => {
                    console.error(err);
                  });
                  // 初复诊
                  this.$ajax.post(base.basePath + 'auth/doctor-patients/authorize/isConnection/' + this.doctor.doctorId).then(res => {
                    if (res.data.status === 'success') {
                      if (!res.data.isOpen) { //不允许预约
                        return;
                      }
                      if (!res.data.isFirst) { // 复诊
                        this.doctor.initialCharge = this.doctor.furtherCharge;
                        // this.doctor.initialMinute = this.doctor.furtherMinute;

                        //this.appoint.payAmount = this.doctor.furtherCharge;
                        this.initAmount = this.doctor.furtherCharge;
                      }
                    }
                  });

                  // 语言
                  vm.$ajax.get(base.basePath + 'auth/doctor-tags/language/' + res.data.data.detail.doctorId).then(res => {
                    if (res.data.status === 'success') {
                      if (res.data.list && res.data.list.length > 0) {
                        for (let tag of res.data.list) {
                          vm.languageTags.push(tag.tagName);
                        }
                      }
                    }
                  });
                }
              } else {
                vm.$message.error(res.data.message);
              }
            }
          })
    },
    getCouponList(doctorId) {
      // 查询我可用的优惠券
      let that = this;
      that.$ajax.get(base.basePath + 'coupon/coupon-user/authorize/usable/me/' + doctorId).then(res => {
        if (res.data.status === 'success') {

          // 去除已有优惠券
          $(res.data.list).each((i, o) => {
            o.checked = false;
            $(that.coupons).each((ci, co) => {
              if (co.id == o.couponRuleId) {
                that.coupons.splice(ci, 1);
                return true;
              }
            })
          });
          that.myCoupons = res.data.list;
        }
      });
    },
    gainCoupon(id) {
      this.$ajax.post(base.basePath + 'coupon/coupon-rule/authorize/receive/self/' + id).then(res => {
        if (res.data.status === 'success') {
          this.$message.success('领取成功');
          this.getCouponList(this.doctor.doctorId);
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error('操作失败');
      })
    },
    selectCBK(choosed) {
      this.clearCouponSelected();
      this.choosed = choosed;
      this.appoint.payAmount = choosed.slotNum * this.doctor.initialCharge;
      this.appoint.totalAmount = choosed.slotNum * this.doctor.initialCharge;
    },
    selectCoupon(item) {
      const selected = this.choosed;
      if (!selected.slotNum) {
        this.$message.warning('请先选择预约时间');
        this.loading = false;
        return;
      }
      let targetChecked;
      targetChecked = !item.checked;
      this.clearCouponSelected();
      item.checked = targetChecked;
      let discountAmount = 0;
      if ((item.couponType == 2 || item.couponType == 3)) {
        discountAmount = this.appoint.totalAmount; // 年/月卡
        // 抵扣次数

        let ableCount = item.limitUseCount - item.usedCount;
        discountAmount = ableCount * this.doctor.initialCharge;
      } else { //优惠券
        if (item.discountMode == 1) { //折扣
          discountAmount = (1 - (item.discountRate / 100)) * this.appoint.totalAmount;
        } else { //定额
          discountAmount = item.discountAmount / 100;
        }
      }
      let totalAmount = this.appoint.totalAmount;
      if (targetChecked) {
        totalAmount = totalAmount - discountAmount;
        if (totalAmount < 0 && item.couponType == 1) {
          item.checked = !targetChecked;
          this.$message.warning('优惠券不可用');
          return;
        }
      }
      this.appoint.payAmount = totalAmount < 0 ? 0 : totalAmount;
    },
    couponPay(item) {
      let that = this;
      that.couponPayDialog.qrLoading = true;

      that.couponPayDialog.couponInfo = item;
      that.couponPayDialog.visible = true;
      // 获取付款码
      that.couponPayDialog.timeDelayer = setTimeout(() => {
        if (!that.couponPayDialog.visible) {
          clearTimeout(that.couponPayDialog.timeDelayer);
          return;
        }
        that.$ajax.post(base.basePath + 'coupon/pay/authorize/pay/' + item.id + '/native').then(res => {
          if (res.data.status === 'success') {
            that.couponPayDialog.qrImgSrc = res.data.url; //5min内有效
            that.couponPayDialog.payCouponNo = res.data.token;
            that.couponPayDialog.expire = res.data.expire; //单位:s

            that.couponPayDialog.qrLoading = false;
            // 定时
            that.couponPayDialog.expireTimer = setInterval(() => {
              if (!that.couponPayDialog.visible) {
                clearInterval(that.couponPayDialog.expireTimer);
                return;
              }
              that.couponPayDialog.expireText = base.utils.secondToDate(that.couponPayDialog.expire);
              that.couponPayDialog.expire--;
              if (that.couponPayDialog.expire < 0) {
                // 倒计时结束
                clearInterval(that.couponPayDialog.expireTimer);
                that.closeCouponPay();
                return;
              }
              // 轮询订单状态 3s间隔
              if (that.couponPayDialog.expire > 0) {
                if (!(that.couponPayDialog.expire % 3 == 0)) {
                  return;
                }
              }
              that.$ajax.post(base.basePath + 'coupon/pay/authorize/isPay/' + res.data.token).then(pollingRes => {
                if (pollingRes.data.status === 'success') {
                  if (pollingRes.data.data == 1) {
                    // 已支付
                    that.closeCouponPay();
                    that.reload();
                    that.$message.success('支付成功');
                  }
                } else {
                  that.$message.error('支付订单错误');
                  that.closeCouponPay();
                }
              }).catch(() => {
                that.$message.error('支付订单错误');
                that.closeCouponPay();
              });
            }, 1000);
          }
        }).catch(() => {
          that.closeCouponPay();
          that.$message.error('获取数据失败');
        });
      }, 2000);
    },
    clearCouponSelected() {
      $(this.myCoupons).each((i, o) => {
        o.checked = false;
      });
    },
    closeCouponPay() {
      let that = this;
      clearTimeout(that.couponPayDialog.timeDelayer);
      clearInterval(that.couponPayDialog.expireTimer);
      that.couponPayDialog.payCouponNo = '';
      that.couponPayDialog.qrImgSrc = '';
    },
    uploadSuccess(response) {
      if (response.status === 'success') {
        this.fileList.push(response.id);
      } else {
        this.$message.error(response.message);
      }
    },
    beforeRemove() {
      return this.$messageBox.confirm('确定要移除文件吗?', '删除提示', {type: 'warning'});
    },
    handleExceed() {
      this.$message.warning('最多上传10个附件');
    },
    handleRemove(file) {
      $(this.fileList).each((i, id) => {
        if (id === file.response.id) {
          this.fileList.splice(i, 1);
          return false;
        }
      });
    },
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal)
      }
    },
    minute: {
      handler(newVal) {
        this.num(newVal)
      }
    }
  },
  computed: {
    second: function () {
      return this.num(this.seconds)
    },
    minute: function () {
      return this.num(this.minutes)
    },
  },
  filters: {
    couponTypeFmt(type) {
      if (type == 2) {
        return '月卡';
      } else if (type == 3) {
        return '年卡'
      }
      return '优惠券';
    },
    couponDiscountFmt(item) {
      if (item.discountMode == 1) { //折扣
        return item.discountRate / 10 + '折';
      } else if (item.discountMode == 2) { //定额
        return '￥' + item.discountAmount / 100;
      }
      return '0';
    }
  },
  components: {
    'appointment': () => import('../appointment/appointment'),
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/consult_b.scss';
</style>
